import { Routes, Route } from "react-router-dom";
import "./App.css";
import RegisterPage from "./pages/Register";
import VerifyPage from "./pages/Verify";
import LoginPage from "./pages/Login";
import UserHome from "./pages/UserHome";
import LearnSubmission from "./pages/LearnSubmission";
import DoSubmission from "./pages/DoSubmission";
import TMISHome from "./pages/TMISHome";
import LearnDo from "./pages/LearnDo";
import LearnDoBoard from "./pages/LearnDoBoard";
import Comparison from "./pages/Comparison";
import Unregister from "./pages/Unregister";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ResendVerification from "./pages/ResendEmail";
import Dashboard from "./pages/Dashboard";
import AuditLogs from "./pages/AuditLogs";
import Profile from "./pages/Profile";
import Report from "./pages/Report";
import EditLearn from "./pages/EditLearn";
import EditDo from "./pages/EditDo";
import Renewal from "./pages/Renewal";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/home" element={<TMISHome />} />
      <Route path="/userhome" element={<UserHome />} />
      <Route path="/learn" element={<LearnSubmission />} />
      <Route path="/do" element={<DoSubmission />} />
      <Route path="/learndo" element={<LearnDo />} />
      <Route path="/board" element={<LearnDoBoard />} />
      <Route path="/comparison" element={<Comparison />} />
      <Route path="/unregister" element={<Unregister />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/resend" element={<ResendVerification />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/auditlogs" element={<AuditLogs />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/report" element={<Report />} />
      <Route path="/renewal" element={<Renewal />} />
      <Route path="/editLearn/:id" element={<EditLearn />} />
      <Route path="/editDo/:id" element={<EditDo />} />
    </Routes>
  );
}

export default App;
